import React from 'react';
import PropTypes from 'prop-types';

const DropdownPortal = ({ children, visible, style }) => {
  return (
    <div className="dropdown-portal" hidden={!visible} style={style}>
      <div className="dropdown">{children}</div>
    </div>
  );
};

DropdownPortal.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default DropdownPortal;
